import React from 'react'
import logo from "../assets/home/logo.svg"

const Header = () => {
  return (
    <div className=' p-4 border-b pl-4 '>
      <div className='flex gap-2 items-center justify-start '>
        <img src={logo} alt="Social Calendar Logo" style={{ height: '44px' }} />

        <div className=''>
            <h1 className=' font-semibold'>Home Assistant</h1>
            <p className='text-sm text-gray-600'>Always here to help</p>
        </div>
      </div>
    </div>
  )
}

export default Header